import type { FC } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { removeURLSearchParams, useWidgetMatchActiveTab } from '@mwl/core-lib';
import { Tabs } from '@mwl/ui';
import { Tab } from '@/components/Tab/Tab';
import { getAnalyticsData } from './MatchWidgetTabs.analitycs';
import type { MatchWidgetTabsProps } from './MatchWidgetTabs.types';
import styles from './MatchWidgetTabs.module.scss';
export const MatchWidgetTabs: FC<MatchWidgetTabsProps> = ({
  tabs,
  hasTranslation,
  className,
  children
}) => {
  const router = useRouter();
  const {
    t
  } = useTranslation('sport');
  const activeTab = useWidgetMatchActiveTab({
    tabs,
    hasTranslation
  });
  return <>
      <nav className={cn(styles.root, className)}>
        <Tabs className={styles.tabs} data-sentry-element="Tabs" data-sentry-source-file="MatchWidgetTabs.tsx">
          {tabs.map(tab => {
          const {
            icon: Icon,
            key,
            label,
            disabled
          } = tab;
          if (disabled) {
            return null;
          }
          return <Tab key={tab.key} className={styles.tab} as="link" href={{
            pathname: removeURLSearchParams({
              url: router.asPath
            }),
            query: {
              wt: key
            }
          }} shallow replace scroll={false} active={activeTab === key} analytics={getAnalyticsData((router?.query?.line_id as string), tab)} label={<span className={styles.tabLabel}>
                    <Icon className={cn(styles.tabIcon, {
              [styles.active]: activeTab === key
            })} />
                    <span className={styles.tabText}>{t(label)}</span>
                  </span>} />;
        })}
        </Tabs>
      </nav>

      {children?.(activeTab)}
    </>;
};